class FooterAccordion {
  constructor(selector, mobileBreakpoint = 768) {
    this.selector = selector;
    this.mobileBreakpoint = mobileBreakpoint;
    this.items = document.querySelectorAll(this.selector);

    this.handleResize = this.handleResize.bind(this);

    this.init();
  }

  init() {
    if (!this.items.length) return;

    this.items.forEach((item) => {
      const heading = item.querySelector('.footer-block__heading');
      const content = item.querySelector('.footer-block__details-content');

      if (!heading || !content) return;

      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');

      heading.addEventListener('click', () => {
        if (!this.isMobile()) return;

        this.toggleItem(item, content);
      });

      heading.addEventListener('keydown', (event) => {
        if (!this.isMobile()) return;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleItem(item, content);
        }
      });
    });

    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  isMobile() {
    return window.innerWidth < this.mobileBreakpoint;
  }

  toggleItem(item, content) {
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      this.closeItem(item, content);
    } else {
      this.openItem(item, content);
    }
  }

  openItem(item, content) {
    item.classList.add('is-open');

    content.style.display = 'block';

    const contentHeight = content.scrollHeight;

    content.style.height = '0px';
    content.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      content.style.transition = 'height 0.3s ease';
      content.style.height = `${contentHeight}px`;
    });

    content.addEventListener(
      'transitionend',
      () => {
        if (item.classList.contains('is-open')) {
          content.style.height = 'auto';
          content.style.overflow = '';
        }
      },
      { once: true }
    );
  }

  closeItem(item, content) {
    item.classList.remove('is-open');

    content.style.height = `${content.scrollHeight}px`;
    content.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      content.style.transition = 'height 0.3s ease';
      content.style.height = '0px';
    });

    content.addEventListener(
      'transitionend',
      () => {
        if (!item.classList.contains('is-open')) {
          content.style.display = 'none';
        }
      },
      { once: true }
    );
  }

  handleResize() {
    this.items.forEach((item) => {
      const content = item.querySelector('.footer-block__details-content');

      if (!content) return;

      if (this.isMobile()) {
        if (!item.classList.contains('is-open')) {
          content.style.display = 'none';
          content.style.height = '0px';
          content.style.overflow = 'hidden';
        }
      } else {
        item.classList.remove('is-open');

        content.style.display = '';
        content.style.height = '';
        content.style.transition = '';
        content.style.overflow = '';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new FooterAccordion('.footer-block--menu', 750);
});




document.addEventListener("click", function (e) {
  const trigger = e.target.closest(".newsletter-cta");

  if (!trigger) return;

  e.preventDefault();

  const src = trigger.dataset.src || trigger.getAttribute("href");

  if (!src || !window.Fancybox) return;

  Fancybox.show([
    {
      src,
      type: "inline"
    }
  ]);
});